import { NgModule } from '@angular/core';
import { WorkOrdersService } from './work-orders.service';
import { WorkOrdersBackend } from './work-orders.backend';

@NgModule({
  providers: [WorkOrdersService, WorkOrdersBackend],
})
export class WorkOrdersModule {}
